import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
type Purchase = {
  name: string;
  province: string;
  initial: string;
  color: string;
  timeAgo: string;
};
const purchases: Purchase[] = [{
  name: 'María L.',
  province: 'Buenos Aires',
  initial: 'M',
  color: 'bg-pink-500',
  timeAgo: 'hace 2 min'
}, {
  name: 'Lucía F.',
  province: 'Córdoba',
  initial: 'L',
  color: 'bg-amber-500',
  timeAgo: 'hace 4 min'
}, {
  name: 'Sofía R.',
  province: 'Mendoza',
  initial: 'S',
  color: 'bg-emerald-500',
  timeAgo: 'hace 7 min'
}, {
  name: 'Camila G.',
  province: 'Santa Fe',
  initial: 'C',
  color: 'bg-sky-500',
  timeAgo: 'hace 9 min'
}, {
  name: 'Florencia M.',
  province: 'Tucumán',
  initial: 'F',
  color: 'bg-fuchsia-500',
  timeAgo: 'hace 12 min'
}, {
  name: 'Valentina P.',
  province: 'Salta',
  initial: 'V',
  color: 'bg-rose-500',
  timeAgo: 'hace 14 min'
}, {
  name: 'Agustina B.',
  province: 'Entre Ríos',
  initial: 'A',
  color: 'bg-indigo-500',
  timeAgo: 'hace 17 min'
}, {
  name: 'Daniela O.',
  province: 'Neuquén',
  initial: 'D',
  color: 'bg-teal-500',
  timeAgo: 'hace 19 min'
}, {
  name: 'Romina S.',
  province: 'Misiones',
  initial: 'R',
  color: 'bg-orange-500',
  timeAgo: 'hace 22 min'
}, {
  name: 'Julieta C.',
  province: 'Chubut',
  initial: 'J',
  color: 'bg-cyan-500',
  timeAgo: 'hace 25 min'
}, {
  name: 'Carolina T.',
  province: 'San Juan',
  initial: 'C',
  color: 'bg-violet-500',
  timeAgo: 'hace 28 min'
}, {
  name: 'Brenda H.',
  province: 'Río Negro',
  initial: 'B',
  color: 'bg-lime-600',
  timeAgo: 'hace 31 min'
}, {
  name: 'Micaela A.',
  province: 'La Pampa',
  initial: 'M',
  color: 'bg-red-500',
  timeAgo: 'hace 34 min'
}, {
  name: 'Antonella V.',
  province: 'Corrientes',
  initial: 'A',
  color: 'bg-purple-500',
  timeAgo: 'hace 38 min'
}, {
  name: 'Paula D.',
  province: 'Jujuy',
  initial: 'P',
  color: 'bg-yellow-600',
  timeAgo: 'hace 42 min'
}];
export function PurchasePopup() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    // Initial delay before first popup
    const initialTimer = setTimeout(() => {
      setVisible(true);
    }, 4000);
    return () => clearTimeout(initialTimer);
  }, []);
  useEffect(() => {
    if (!visible) {
      // After hide, wait 15s, then show next
      const showNext = setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % purchases.length);
        setVisible(true);
      }, 15000);
      return () => clearTimeout(showNext);
    } else {
      // Visible for 5s
      const hideTimer = setTimeout(() => {
        setVisible(false);
      }, 5000);
      return () => clearTimeout(hideTimer);
    }
  }, [visible]);
  const current = purchases[currentIndex];
  return <div className="fixed bottom-4 left-4 z-50 pointer-events-none max-w-[calc(100vw-2rem)]" data-id="element-242">
      <AnimatePresence data-id="element-243">
        {visible && <motion.div initial={{
        opacity: 0,
        x: -40,
        y: 10
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: -40,
        y: 10
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="bg-white rounded-xl shadow-2xl border border-slate-200 p-3 flex items-center gap-3 max-w-xs pointer-events-auto" data-id="element-244">
            <div className={`w-10 h-10 rounded-full ${current.color} text-white flex items-center justify-center font-bold text-base shrink-0`} data-id="element-245">
              {current.initial}
            </div>
            <div className="flex-1 min-w-0" data-id="element-246">
              <p className="text-sm font-semibold text-slate-900 leading-tight" data-id="element-247">
                {current.name}{' '}
                <span className="font-normal text-slate-500" data-id="element-248">
                  de {current.province}
                </span>
              </p>
              <p className="text-xs text-slate-600 flex items-center gap-1 mt-0.5" data-id="element-249">
                <CheckCircleIcon sx={{
              fontSize: 12
            }} className="text-green-500" data-id="element-250" />
                Acaba de comprar
                <span className="text-slate-400" data-id="element-251">· {current.timeAgo}</span>
              </p>
            </div>
            <button onClick={() => setVisible(false)} className="text-slate-400 hover:text-slate-600 shrink-0 self-start" aria-label="Cerrar" data-id="element-252">
              <CloseIcon sx={{
            fontSize: 16
          }} data-id="element-253" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}